import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AddReminderComponent } from '../components/add-reminder/add-reminder.component';
import { roleConstant } from '../app.constant';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { ModalComponent } from '../components/modal/modal.component';
import { CreateFormComponent } from '../components/create-form/create-form.component';
import { AuthenticationService } from '../services/authentication.service';
import { DataSharedService } from '../services/data-shared.service';
import { ActivityLogsService } from '../services/activity-logs.service';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})

export class SettingsComponent implements OnInit, OnDestroy {
  selectedAgencyLogo: string = '';
  user: any;
  ROLES = roleConstant;
  isSettingsHome: boolean = true;
  private routerSub!: Subscription;

  constructor(
    private modalService: NgbModal,
    private dataSharedService: DataSharedService,
    private router: Router,
    private authService: AuthenticationService,
    private activityLogsService: ActivityLogsService,
  ) {
    this.user = this.authService.userValue;
    this.activityLogsService.logPageVisit('settings').subscribe();
  }

  ngOnInit(): void {
    this.isSettingsHome = this.router.url === '/settings';
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.isSettingsHome = event.url === '/settings';
      });
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  openTimesheetDetails() {
    const modalRef = this.modalService.open(ModalComponent, { size: 'xl' });
  }

  gotoForms() {
    this.router.navigate(['/timesheet-forms']);
  }

  changePassword() {
    this.router.navigate(['/change-password']);
  }

  addReminder() {
    this.router.navigate(['/reminders']);
  }

  async onImageChange(imageInput: any) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();

    reader.readAsDataURL(file);
    this.selectedAgencyLogo = await new Promise(resolve => {
      reader.addEventListener('load', (event: any) => {
        resolve(new ImageSnippet(event.target.result, file).src);
      });
    })
    console.log(this.selectedAgencyLogo);
  }

  uploadAgencyLogo() {
    this.dataSharedService.uploadAgencyLogo(this.selectedAgencyLogo).subscribe((res: any) => {
      console.log(res);
    })
  }

}

class ImageSnippet {
  constructor(public src: string, public file: File) { };
};
